import {
  AdsRenderingStatus,
  AdStatusInfo,
  DeletedAdsAction,
  GenerateAdsChanges,
  GenerateAdsStatus,
  GenerateAdsValidationIssue,
  PauseAdsAction,
  SocialAd,
  SocialAdMediaRenderingStatus,
} from 'common/src/modules/externalAds/externalAds.types';
import {MediaStatusResponse} from 'common/src/modules/media/media.types';

type PublishAndActivateParams = {
  pauseAdsAction?: PauseAdsAction;
  deleteAdsAction?: DeletedAdsAction;
  autoActivate?: {
    activateOnFailPublish: boolean;
    activationOption: number;
    versionName: string;
    versionDescription: string;
    futureActivation: {
      cron: string;
      timeZone: string;
    };
  };
};

type AdsGeneration = {
  inProgress: boolean;
  status: GenerateAdsStatus | null;
  changes: GenerateAdsChanges;
  issues: GenerateAdsValidationIssue[];
};

enum AdsTableModalAction {
  None = 'None',
  ActionsDropDown = 'ActionsDropDown',
  AddProperties = 'AddProperties',
  DV360InfoModal = 'DV360InfoModal',
  PublishAndActivateModal = 'PublishAndActivateModal',
  DV360SyncModal = 'DV360SyncModal',
}

type AdsTabState = {
  _loading: boolean;
  ads: SocialAd[];
  adsRenderingStatus: AdsRenderingStatus | null;
  adsStatusInfo: Record<string, AdStatusInfo>;
  adsStatusInfoLoading: boolean;
  prevVersionAdCount: number;
  adsGeneration: AdsGeneration;
  mediaRenderingStatus: Record<number, SocialAdMediaRenderingStatus>;
  adsLastUpdateTime: string | null;
  modalAction: AdsTableModalAction;
  showAdsWithIssuesFilter: boolean;
  selectedRowIds: number[];
  dv360CampaignSyncing: boolean;
  dv360CVSdownloadInProgress: boolean;
  isPublishAndActivateModalOpen: boolean;
  mediaRenderingStatuses: MediaStatusResponse[];
  areAdsUpdated: boolean;
  canBeSkippedToPublish: boolean;
};

export {AdsTabState, AdsGeneration, AdsTableModalAction, PublishAndActivateParams};
